
/* == CREATES VARIANT CHANGE EVENT == */

(function () {
    const SELECTORS = {
        root: "[data-mb-variants]",
        variantsJson: "[data-mb-variants-json]",
        optionInput: "[data-mb-option-input]",
    };

    function initVariants(root) {
        const variantsDataEl = root.querySelector(SELECTORS.variantsJson);
        if (!variantsDataEl) return;

        const variants = JSON.parse(variantsDataEl.textContent);

        root.addEventListener("change", (e) => {
            if (e.target.matches(SELECTORS.optionInput)) {
                const selectedVariant = getSelectedVariant(root, variants);
                if (selectedVariant) {
                    dispatchVariantChange(root, selectedVariant);
                }
            }
        });
    }

    function getSelectedVariant(root, variants) {
        const selectedOptions = Array.from(root.querySelectorAll(SELECTORS.optionInput + ":checked"))
            .map(input => input.value);

        // Find the variant where the options array matches our selected array
        return variants.find(variant =>
            variant.options.every((option, index) => option === selectedOptions[index])
        );
    }

    function dispatchVariantChange(root, variant) {
        root.dispatchEvent(
            new CustomEvent("mb:variant:change", {
                bubbles: true,
                detail: {
                    variantId: variant.id,
                    variant: variant
                }
            })
        );
    }

    // Initialize
    const variantRoot = document.querySelector(SELECTORS.root);
    if (variantRoot) initVariants(variantRoot);
})();


/*
(function () {
    const SELECTORS = {
        root: "[data-mb-variants]",
        variantsJson: "[data-mb-variants-json]",
        optionInput: "[data-mb-option-input]",
    };

    function initVariants(root) {
        const variantsDataEl = root.querySelector(SELECTORS.variantsJson);
        if (!variantsDataEl) return;

        const variants = JSON.parse(variantsDataEl.textContent);
        const optionInputs = root.querySelectorAll(SELECTORS.optionInput);

        if (!variants || !optionInputs.length) return;

        optionInputs.forEach(input => {
            input.addEventListener("change", () => {
                const selectedVariant = getSelectedVariant(root, variants);
                if (!selectedVariant) return;

                dispatchVariantChange(root, selectedVariant);
            });
        });

        const initialVariant = getSelectedVariant(root, variants);
        if (initialVariant) {
            dispatchVariantChange(root, initialVariant);
        }
    }

    function getSelectedVariant(root, variants) {
        const selectedOptions = [];

        root.querySelectorAll(SELECTORS.optionInput + ":checked").forEach(input => {
            selectedOptions.push(input.value);
        });

        console.log(selectedOptions);


        return variants.find(variant =>
            variant.options.every((option, index) => option === selectedOptions[index])
        );

    }

    function dispatchVariantChange(root, variant) {
        root.dispatchEvent(
            new CustomEvent("mb:variant:change", {
                bubbles: true,
                detail: {
                    variantId: variant.id,
                    variant
                }
            })
        );
    }

    function initAll(root = document) {
        root.querySelectorAll(SELECTORS.root).forEach(initVariants);
    }

    document.addEventListener("DOMContentLoaded", () => initAll());
    document.addEventListener("shopify:section:load", e => initAll(e.target));
})();

*/